module.exports = __webpack_public_path__ + "static/pinsent-masons--dark-3b9fdc38036626ced14bd2bbc14bcead.png";